import DetailPageLayout from "../Layout/DetailPageLayout";
import { useMyTickets } from "./MyTicketList.helpers";
import { Helmet } from "react-helmet";
import { ContentContainer, ScrollContainer } from "./MyTicketList.styles";
import { CenterContainer } from "../../common/components";
import { TailSpin } from "react-loader-spinner";
import { BsCartX } from "react-icons/bs";
import { TextMS } from "../../common/text";
import TicketCard from "./TicketCard";

const MyTicketList = () => {
  const { isSuccess, data: myTickets, isLoading } = useMyTickets();

  return (
    <DetailPageLayout headerText={"구매내역"}>
      <Helmet>
        <title>구매내역</title>
      </Helmet>
      <ContentContainer>
        {isLoading && (
          <CenterContainer style={{ gap: "20px" }}>
            <TailSpin
              height={"100px"}
              width={"100px"}
              color={"grey"}
            ></TailSpin>
          </CenterContainer>
        )}
        {isSuccess && myTickets.length === 0 && (
          <CenterContainer style={{ gap: "20px" }}>
            <BsCartX size={50} />
            <TextMS>6개월 내에 조회된 티켓이 없습니다.</TextMS>
          </CenterContainer>
        )}
        {isSuccess && myTickets.length !== 0 && (
          <ScrollContainer>
            {myTickets.map((ticket) => (
              <TicketCard key={ticket.pk} ticket={ticket} />
            ))}
          </ScrollContainer>
        )}
      </ContentContainer>
    </DetailPageLayout>
  );
};

export default MyTicketList;
